
export default function PreOrderCTA() {
  return (
    <section className="py-16 md:py-24 lg:py-32 bg-gradient-to-br from-[#1A1A2E] to-[#2D2D44] relative overflow-hidden">
      <div className="max-w-[1200px] mx-auto px-4 md:px-8 text-center relative z-10">
        <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-4 md:mb-6" style={{ fontFamily: "'Anton', sans-serif" }}>
          맞춤 부품 상담
        </h2>

        <p className="text-sm md:text-base text-white/90 mb-8 md:mb-12 max-w-2xl mx-auto font-light leading-relaxed" style={{ fontFamily: "'Inter', sans-serif" }}>
          차량에 맞는 최적의 부품을 찾고 계신가요? 전문가와 상담하세요. 차종별 호환 부품을 정확하게 안내해 드립니다.
        </p>

        <div className="flex flex-col sm:flex-row gap-3 md:gap-6 justify-center items-center">
          <a
            href="/contact"
            className="px-8 md:px-12 py-3.5 md:py-5 bg-[#E63946] text-white text-sm md:text-lg font-bold tracking-wider hover:bg-[#C1121F] transition-all shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer rounded-md"
            style={{ fontFamily: "'Anton', sans-serif" }}
          >
            상담 신청하기
          </a>
          <a
            href="/shop"
            className="px-8 md:px-12 py-3.5 md:py-5 bg-transparent border-2 border-white text-white text-sm md:text-lg font-bold tracking-wider hover:bg-white hover:text-[#1A1A2E] transition-all whitespace-nowrap cursor-pointer rounded-md"
            style={{ fontFamily: "'Anton', sans-serif" }}
          >
            전체 제품 보기
          </a>
        </div>
      </div>
    </section>
  );
}
